import { render, staticRenderFns } from "./ProfileEditFormPanel.vue?vue&type=template&id=920cd3dc&scoped=true"
import script from "./ProfileEditFormPanel.vue?vue&type=script&lang=js"
export * from "./ProfileEditFormPanel.vue?vue&type=script&lang=js"
import style0 from "./ProfileEditFormPanel.vue?vue&type=style&index=0&id=920cd3dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "920cd3dc",
  null
  
)

export default component.exports